/**
 * Name: New Playlist Saga
 * Author: @Gaurav
 * Date: 19-07-21
 */
import { put, takeLatest, call } from 'redux-saga/effects';
import ApiCaller from '../ApiCaller';

const callAPI = (payload) => {
  return ApiCaller('/v1/admin/playlist', 'POST', payload);
};
export default function* watchRequest() {
  yield takeLatest('NEW_PLAYLIST', function* performAction(action) {
    yield put({ type: 'NEW_PLAYLIST_INITIATED' });
    try {
      const data = yield call(callAPI.bind(this, action.payload));
      yield put({ type: 'NEW_PLAYLIST_SUCCESS', payload: data });
    } catch (error) {
      yield put({ type: 'NEW_PLAYLIST_FAILED', payload: error });
    }
  });
}
